import React, { useContext, useEffect } from "react";
import "./SimplePages.css";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";

export const Privacy = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);

  useEffect(() => {
    setTitle("Privacy Policy");
    setLoading(false);
  }, []);

  return (
    <div className="simple-content ">
      <p className="simple-content-description text-start">
        <p className="c11">
          <span>
            Coca-Cola Europacific Partners plc and its subsidiaries and
            affiliates (&quot;&nbsp;CCEP&nbsp;&quot;,
            &quot;&nbsp;we&nbsp;&quot;) are committed to respecting your privacy
            and to manage your personal data fairly and safely. With this
            Privacy Notice, we would like to inform you why and how we may
            process your personal data when you participate in one of our
            marketing campaigns. For more information about CCEP and our general
            privacy notice, please visit our website{" "}
          </span>
          <span className="c20">
            <a
              className="c9 content-link"
              href="https://www.google.com/url?q=http://www.cocacolaep.com&amp;sa=D&amp;source=editors&amp;ust=1656084474210088&amp;usg=AOvVaw15vGPDPYCcworYryNs4bxX"
            >
              www.cocacolaep.com
            </a>
          </span>
          <span>&nbsp;or refer to</span>
          <span className="c8">&nbsp;</span>
          <span>the</span>
          <span className="c8">&nbsp;Contact us</span>
          <span className="c1">&nbsp;section below. </span>
        </p>
        <p className="c14">
          <span className="c1">
            The entity responsible for the processing of data relating to the
            marketing campaign carried out in Great Britain is Coca-Cola
            Europacific Partners Great Britain Limited whose head office is
            located Pemberton House, Bakers Road, Uxbridge, UB8 1EZ
            (hereinafter, &quot;&nbsp;CECPB&nbsp;&quot; or
            &quot;&nbsp;we&nbsp;&quot;). Our main business is bottling, selling
            and marketing Coca -Cola products.{" "}
          </span>
        </p>
        <p className="c10 c14">
          <span className="c1"></span>
        </p>
        <ol className="c6 lst-kix_list_6-0 start" start="1">
          <li className="c2 li-bullet-0">
            <span className="c1">Personal data we collect</span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">Purposes and legal grounds </span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">How we disclose Personal Data </span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">International data transfers </span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">Retention periods </span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">Your rights and choices </span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">Changes to this Privacy notice </span>
          </li>
          <li className="c2 li-bullet-0">
            <span className="c1">Contact us </span>
          </li>
        </ol>
        <p className="c19 c10">
          <span className="c13"></span>
        </p>
        <ol className="c6 lst-kix_list_8-0 start" start="1">
          <li className="c7 li-bullet-1">
            <span className="c13">PERSONAL DATA WE COLLECT </span>
          </li>
        </ol>
        <p className="c4 c10">
          <span className="c1"></span>
        </p>
        <p className="c4">
          <span className="c1">
            We may collect personal data in connection with the performance of
            any activity that is part of our operations. We may collect or
            obtain this data because you provide it to us (for example via a
            form), because other people provide it to us (for example, your
            employer or third-party service providers we use to assist us in our
            operations) or because they are public.{" "}
          </span>
        </p>
        <p className="c4 c10">
          <span className="c1"></span>
        </p>
        <p className="c4">
          <span className="c1">
            When we obtain personal data about you through other parties, we
            make reasonable efforts to include clauses in our contract with
            those parties, requiring that they comply with the privacy laws and
            regulations. This may include, for example, requirement to provide
            you with adequate privacy notice and obtain the necessary consent so
            that we may process this information in the manner described in this
            Privacy Notice.
          </span>
        </p>
        <p className="c4 c10">
          <span className="c1"></span>
        </p>
        <p className="c4">
          <span className="c1">
            We may also collect or obtain personal data from you, as we observe
            or deduct such data about you in the way you interact with us or
            other parties.{" "}
          </span>
        </p>
        <p className="c11">
          <span className="c1">
            In this Privacy Notice, &quot;Personal Data&quot; refers to any
            information relating to an identified or identifiable individual.
            For example, your personal data includes&nbsp;your name, email
            address, IP address, and phone number. We may collect the following
            personal data:
          </span>
        </p>
        <ul className="c6 lst-kix_list_7-0 start">
          <li className="c5 li-bullet-0">
            <span className="c17">Contact information</span>
            <span>
              , such as your name, address, telephone number, e -mail address
              (private or business), country of residence.{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Correspondence</span>
            <span className="c1">
              , such as the content, date and time of emails, chats, social
              media messages and other communications with you, as well as
              details of your preferences for interactions with us and similar
              information.{" "}
            </span>
          </li>
        </ul>
        <p className="c11">
          <span className="c1">
            Where applicable, we indicate whether and why you must provide us
            with your personal data, as well as the consequences of failing to
            do so. For example, if certain personal data is necessary to provide
            services you have requested, or if we are legally required to
            collect it, and you decline to provide us with that personal data,
            then we cannot provide you with the services you have requested.
          </span>
        </p>
        <ol className="c6 lst-kix_list_8-0" start="2">
          <li className="c3 li-bullet-1">
            <span className="c13">PURPOSES AND LEGAL GROUNDS </span>
          </li>
        </ol>
        <p className="c11">
          <span>We use your data for the following purposes:</span>
          <span className="c8 c22">&nbsp;</span>
        </p>
        <ul className="c6 lst-kix_list_7-0">
          <li className="c5 li-bullet-0">
            <span className="c17">Participation in our campaigns:</span>
            <span>
              &nbsp;To enable you to participate in our marketing campaigns and
              to provide you with all the related services.{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Communication with you:</span>
            <span className="c1">
              &nbsp;To respond to your requests and comments, to provide you
              with the information you have requested.{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Managing our relationship with you:</span>
            <span className="c1">
              &nbsp;To manage your current relationship with us, including
              managing contractual obligations and other obligations, interact
              with you, inform you about our products or services, as well as
              special offers and promotions.{" "}
            </span>
          </li>
        </ul>
        <p className="c11">
          <span>
            We only process your personal data based on a valid legal ground,
            including when:{" "}
          </span>
        </p>
        <ul className="c6 lst-kix_list_7-0">
          <li className="c5 li-bullet-0">
            <span className="c1">
              You have consented to the use of your personal data, for example
              when you consent to receive marketing communications from us;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              We need your personal data to enter into, or perform an agreement
              with you, for example to process orders or participate in a
              promotional campaign;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              We have a legal obligation to use your personal data, for example
              to comply with tax and accounting obligations;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              We have a legitimate interest in using your personal data. For
              example, CCEP has a legitimate interest in using your personal
              data to conduct market research, product development and internal
              analytics, and otherwise to improve the safety, security and
              performance of our services. We only rely on our or a third
              party&rsquo;s legitimate interests to process your personal data
              when these interests are not overridden by your rights and
              interests.
            </span>
          </li>
        </ul>
        <ol className="c6 lst-kix_list_8-0" start="3">
          <li className="c7 li-bullet-1">
            <span className="c13">HOW WE DISCLOSE PERSONAL DATA </span>
          </li>
        </ol>
        <p className="c11">
          <span>
            We may disclose information to third parties with your consent, as
            well&nbsp;as in the following circumstances:{" "}
          </span>
        </p>
        <ul className="c6 lst-kix_list_7-0">
          <li className="c5 li-bullet-0">
            <span className="c17">CCEP Group companies. </span>
            <span className="c1">
              We may disclose your personal data about you to other members of
              the CCEP Group of companies.{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Service providers. </span>
            <span className="c1">
              We may disclose your personal data to third party service
              providers who provide us with application development, hosting,
              maintenance, and other services. These third parties may have
              access to or process personal data about you as part of providing
              those services for us. We limit the personal data provided to
              these service providers to that which is reasonably necessary for
              them to perform their functions, and we require them to agree to
              maintain the confidentiality of such information.
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Business partners. </span>
            <span className="c1">
              We may disclose your personal data to partners like customers,
              brand owners, distributors, joint ventures and others in
              conducting our business
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">
              Compliance with laws and law enforcement.{" "}
            </span>
            <span className="c1">
              We may disclose your personal data as required by law or when we
              believe that disclosure is necessary to protect the security or
              integrity of our services, or to protect the legitimate interests,
              rights, property, or safety of CCEP, its employees, users, or
              others, or to comply with a judicial proceeding, court order, or
              governmental or regulatory request or any other legal process
              served on us.
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Business transfers. </span>
            <span className="c1">
              We may disclose personal data to an acquirer, successor, or
              assignee of our company as part of any merger, acquisition, debt
              financing, sale of assets, or similar transaction, or in the event
              of an insolvency, bankruptcy, or receivership in which information
              is transferred to one or more third parties as one of our business
              assets.
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Advertising partners. </span>
            <span className="c1">
              With your consent, we may transfer your personal data to third
              party advertisers or sponsors for direct marketing purposes,
              including targeted advertising, for example to reach a particular
              audience.
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c17">Aggregated data. </span>
            <span className="c1">
              We may pass aggregated information to third parties but this will
              not include information that could be used to identify you.
            </span>
          </li>
        </ul>
        <p className="c10 c19">
          <span className="c13"></span>
        </p>
        <ol className="c6 lst-kix_list_8-0" start="4">
          <li className="c7 li-bullet-2">
            <span className="c13">INTERNATIONAL DATA TRANSFERS </span>
          </li>
        </ol>
        <p className="c11">
          <span className="c1">
            We may transfer your personal data to recipients in countries
            outside of the European Union and the United Kingdom whose laws may
            not provide the same level of data protection. When we do so, we
            will ensure that there are adequate safeguards in place to protect
            your personal data that comply with our legal obligations. The
            adequate safeguard might be a data transfer agreement with the
            recipient based on standard contractual clauses approved by the
            relevant authorities for transfers of personal data to third
            countries.
          </span>
        </p>
        <p className="c11">
          <span className="c1">
            For more information about the transfers described above and the
            sufficient guarantees we use to protect these transfers, you can
            contact us using the contact information below.{" "}
          </span>
        </p>
        <ol className="c6 lst-kix_list_8-0" start="5">
          <li className="c7 li-bullet-1">
            <span className="c13">RETENTION PERIODS </span>
          </li>
        </ol>
        <p className="c11">
          <span className="c1">
            We take steps to erase your personal data or to keep it in a form
            that does not identify you when that information is no longer needed
            for the purposes for which we process it, unless we are required by
            law to keep it longer.{" "}
          </span>
        </p>
        <p className="c11">
          <span className="c1">
            When determining the retention period, we take into account several
            criteria, such as the type of services we provide to you or that you
            provide us, the nature and duration of our relationship with you, a
            possible re-registration in our services, the impact on our services
            if we delete certain information you have provided to us or about
            you, the mandatory retention periods provided by law and the
            corresponding limitation period.{" "}
          </span>
        </p>
        <ol className="c6 lst-kix_list_8-0" start="6">
          <li className="c7 li-bullet-2">
            <span className="c13">YOUR RIGHTS AND CHOICES </span>
          </li>
        </ol>
        <p className="c11">
          <span>
            You can contact us at any time for assistance regarding the
            processing of your personal data. In addition, you have the
            right&nbsp;at any time to:{" "}
          </span>
        </p>
        <ul className="c6 lst-kix_list_7-0">
          <li className="c5 li-bullet-0">
            <span className="c1">
              To obtain confirmation that we are processing your personal data
              and to request a copy of the personal data that we hold about you;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              Request that we update your personal data, or correct any personal
              data that you believe is incorrect or incomplete;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              To request that we delete your personal data, or that we limit our
              use of your personal data if you believe that there is no (longer
              a) a lawful ground for us to process it;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              Withdraw your consent to the processing of your personal data (to
              the extent such processing is based on consent);{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              Receive a copy of the personal data concerning you, which you have
              provided to us, in a structured, commonly used, machine-readable
              format and to transmit such personal data to another party (to the
              extent that processing is based on consent or a contract)&nbsp;;{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              Object to our processing of your personal data for which we use a
              legitimate interest as a legal basis, in which case we will cease
              the processing unless we have compelling legitimate grounds for
              the processing; and{" "}
            </span>
          </li>
          <li className="c5 li-bullet-0">
            <span className="c1">
              You also have the right to object at any time to the processing of
              your personal data for direct marketing. If you no longer wish to
              receive direct marketing from us, you can contact us or click on
              the unsubscribe link in any such communication.{" "}
            </span>
          </li>
        </ul>
        <p className="c4">
          <span className="c1">
            In order to exercise your rights, you can send us a request,
            indicating the right you wish to exercise by contacting us as
            indicating at the bottom of this Privacy Notice. However, there are
            exceptions and limitations to each of these rights. We may, for
            example, charge a reasonable fee or refuse to act on a request if it
            is manifestly unfounded or excessive, in particular because of its
            repetitive character. In some situations, we may refuse to act or
            may impose limitations on your rights if, for instance, your request
            is likely to adversely affect the rights and freedoms of others,
            prejudice the execution or enforcement of the law, interfere with
            pending or future litigation, or infringe applicable law. In all
            cases, you have a right to file a complaint with a data protection
            authority.
          </span>
        </p>
        <ol className="c6 lst-kix_list_8-0" start="7">
          <li className="c7 li-bullet-1">
            <span className="c13">CHANGES TO THIS PRIVACY NOTICE </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c1">
            We may modify or amend this Privacy Notice from time to time. Any
            changes we may make to this Privacy Notice in the future will be
            posted on this page. To let you know when we make changes to this
            Privacy Notice, we will amend the revision date at the top of this
            page. The new modified or amended Privacy Notice will apply from
            that revision date. Please check back periodically to see changes
            and additions.
          </span>
        </p>
        <ol className="c6 lst-kix_list_8-0" start="8">
          <li className="c7 li-bullet-1">
            <span className="c13">CONTACT US </span>
          </li>
        </ol>
        <p className="c11">
          <span>
            If you have any questions about this Privacy Notice or our privacy
            practices in general, please contact us via our{" "}
          </span>
          <span className="c17 c20">
            <a
              className="c9 content-link no-break"
              href="https://www.google.com/url?q=https://privacyportal-eu.onetrust.com/webform/3f3bd182-6198-4d2b-9408-2fd18c944e35/8a8485c4-805b-4c74-8f96-e7fb84703be8&amp;sa=D&amp;source=editors&amp;ust=1656084474222615&amp;usg=AOvVaw242q9VxpDECpqDBH9f0FGv"
            >
              contact form
            </a>
          </span>
          <span>, or via post at: </span>
        </p>
        <p className="c0">
          <span className="c1">
            Coca-Cola Europacific Partners Services srl/bv{" "}
          </span>
        </p>
        <p className="c0">
          <span className="c1">Attention:&nbsp;Privacy Office </span>
        </p>
        <p className="c0">
          <span className="c1">Chauss&eacute;e de Mons 1424 </span>
        </p>
        <p className="c0">
          <span className="c1">Brussels 1070 </span>
        </p>
        <p className="c0">
          <span className="c1">Belgium </span>
        </p>
        <p className="c11">
          <span>
            You can also contact our Data Protection Officer by e-mail at{" "}
          </span>
          <span className="c22 c23">
            <a
              className="c9 content-link no-break"
              href="mailto:privacy@ccep.com"
            >
              privacy@ccep.com
            </a>
          </span>
          <span className="c1">. </span>
        </p>
        <p className="c11">
          <span>
            If you have any questions regarding activation in particular, please
            contact us by email at{" "}
            <a
              className="content-link"
              href="mailto:wincokemusic@meshmarketing.co.uk"
            >
              wincokemusic@meshmarketing.co.uk
            </a>
          </span>
          <span className="c8">&nbsp;</span>
        </p>
        <p className="c11 c10">
          <span className="c18"></span>
        </p>
        <p className="c4 c10">
          <span className="c1"></span>
        </p>
        <p className="c4 c10">
          <span className="c1"></span>
        </p>
      </p>
    </div>
  );
};
